import { defineMessages } from '../define';

/** Общие компоненты и листы ввода. */
export const components = defineMessages({
  ru: {
    'components.category': 'Категория',
    'components.currency': 'Валюта',
    'components.close': 'Закрыть',
    'components.amount': 'Сумма',
    'components.amountRequired': 'Введите сумму',
    'components.amountPositive': 'Сумма должна быть больше нуля',
    'components.amountInvalid': 'Некорректная сумма',
    'components.back': 'Назад',
    'components.settings': 'Настройки',
    'components.prevPeriod': 'Предыдущий период',
    'components.nextPeriod': 'Следующий период',
    'components.backToCurrent': (p: { label: string }) => `${p.label}: вернуться к текущему периоду`,
    'components.loading': 'Загрузка',
    'components.retry': 'Повторить',
    'components.today': 'Сегодня',
    'components.yesterday': 'Вчера',
    'components.date': 'Дата',
    'components.otherDate': 'Другая дата',
    'components.txDate': 'Дата траты',
    'components.name': 'Название',
    'components.nameRequired': 'Введите название',
    'components.note': 'Заметка',
    'components.optional': 'необязательно',
    'components.save': 'Сохранить',
    'components.dayError': 'День должен быть от 1 до 31',
    'components.noLimit': 'без лимита',
    'components.payment.deleteConfirm': (p: { name: string }) => `Удалить платёж «${p.name}»?`,
    'components.payment.new': 'Новый платёж',
    'components.payment.planSubtitle': (p: { amount: string; date: string }) => `План: ${p.amount} · до ${p.date}`,
    'components.payment.namePlaceholder': 'Аренда',
    'components.payment.plannedAmount': (p: { currency: string }) => `Плановая сумма, ${p.currency}`,
    'components.payment.day': 'День месяца',
    'components.payment.dayHint': 'Если в месяце меньше дней, платёж сдвинется к последнему.',
    'components.payment.categoryHint': 'Категория нужна, чтобы платёж попал в бюджет.',
    'components.payment.categoriesFailed': 'Категории не загрузились',
    'components.payment.monthly': 'Повторяется ежемесячно',
    'components.payment.paid': 'Оплачено',
    'components.payment.paidOn': 'Отмечено как оплаченное',
    'components.payment.paidHint': 'Отметка действует только на выбранный период',
    'components.payment.actualAmount': (p: { currency: string }) => `Фактическая сумма, ${p.currency}`,
    'components.payment.actualHint': 'Оставьте пустым, если списалось ровно как в плане.',
    'components.payment.actualPlaceholder': (p: { amount: string }) => `как в плане (${p.amount})`,
    'components.payment.delete': 'Удалить платёж',
    'components.envelope.removeConfirm': (p: { name: string }) => `Убрать конверт «${p.name}»? Траты и история останутся.`,
    'components.envelope.removeOk': 'Убрать',
    'components.envelope.title': 'Конверт',
    'components.envelope.new': 'Новый конверт',
    'components.envelope.namePlaceholder': 'Продукты',
    'components.envelope.limit': (p: { period: string; currency: string }) => `Лимит на ${p.period}, ${p.currency}`,
    'components.envelope.carriedHint': (p: { sum: string }) => `В лимите ${p.sum} перенесено из прошлого периода.`,
    'components.envelope.limitHint': 'Если пусто, конверт без лимита просто считает траты.',
    'components.envelope.color': 'Цвет',
    'components.envelope.colorAria': 'Цвет конверта',
    'components.envelope.create': 'Завести конверт',
    'components.envelope.remove': 'Убрать конверт',
    'components.tx.deleteConfirm': 'Удалить эту трату?',
    'components.tx.title': 'Трата',
    'components.tx.fromPayment': 'Создана из планового платежа',
    'components.tx.amount': 'Сумма траты',
    'components.tx.dateHint': 'Если перенести трату в другой период, она уедет в его бюджет.',
    'components.tx.delete': 'Удалить трату',
    'components.sub.deleteConfirm': (p: { name: string }) => `Удалить подписку «${p.name}»?`,
    'components.sub.new': 'Новая подписка',
    'components.sub.subtitle': 'Регулярное списание',
    'components.sub.amount': (p: { currency: string }) => `Сумма в месяц, ${p.currency}`,
    'components.sub.day': 'День списания',
    'components.sub.dayHint': 'В коротких месяцах 29–31 сдвигается к последнему дню.',
    'components.sub.noteHint': 'Например, с какой карты списывается.',
    'components.sub.delete': 'Удалить подписку',
    'components.entry.left': (p: { sum: string }) => `осталось ${p.sum}`,
    'components.entry.envelope': 'Конверт',
    'components.entry.description': (p: { name: string }) => `Новая трата в конверт «${p.name}»`,
    'components.entry.currencySwitch': (p: { currency: string }) => `Валюта ${p.currency}, сменить`,
    'components.entry.erase': 'Стереть',
    'components.entry.submit': (p: { sum: string }) => `Записать ${p.sum}`,
  },
  en: {
    'components.category': 'Category',
    'components.currency': 'Currency',
    'components.close': 'Close',
    'components.amount': 'Amount',
    'components.amountRequired': 'Enter an amount',
    'components.amountPositive': 'Amount must be greater than zero',
    'components.amountInvalid': 'Invalid amount',
    'components.back': 'Back',
    'components.settings': 'Settings',
    'components.prevPeriod': 'Previous period',
    'components.nextPeriod': 'Next period',
    'components.backToCurrent': (p: { label: string }) => `${p.label}: back to the current period`,
    'components.loading': 'Loading',
    'components.retry': 'Retry',
    'components.today': 'Today',
    'components.yesterday': 'Yesterday',
    'components.date': 'Date',
    'components.otherDate': 'Other date',
    'components.txDate': 'Expense date',
    'components.name': 'Name',
    'components.nameRequired': 'Enter a name',
    'components.note': 'Note',
    'components.optional': 'optional',
    'components.save': 'Save',
    'components.dayError': 'Day must be between 1 and 31',
    'components.noLimit': 'no limit',
    'components.payment.deleteConfirm': (p: { name: string }) => `Delete payment "${p.name}"?`,
    'components.payment.new': 'New payment',
    'components.payment.planSubtitle': (p: { amount: string; date: string }) => `Planned: ${p.amount} · due ${p.date}`,
    'components.payment.namePlaceholder': 'Rent',
    'components.payment.plannedAmount': (p: { currency: string }) => `Planned amount, ${p.currency}`,
    'components.payment.day': 'Day of month',
    'components.payment.dayHint': 'If the month has fewer days, the payment moves to the last one.',
    'components.payment.categoryHint': 'A category puts the payment into the budget.',
    'components.payment.categoriesFailed': 'Categories failed to load',
    'components.payment.monthly': 'Repeats monthly',
    'components.payment.paid': 'Paid',
    'components.payment.paidOn': 'Marked as paid',
    'components.payment.paidHint': 'The mark applies only to the selected period',
    'components.payment.actualAmount': (p: { currency: string }) => `Actual amount, ${p.currency}`,
    'components.payment.actualHint': 'Leave empty if the charge matched the plan exactly.',
    'components.payment.actualPlaceholder': (p: { amount: string }) => `as planned (${p.amount})`,
    'components.payment.delete': 'Delete payment',
    'components.envelope.removeConfirm': (p: { name: string }) => `Remove envelope "${p.name}"? Expenses and history will stay.`,
    'components.envelope.removeOk': 'Remove',
    'components.envelope.title': 'Envelope',
    'components.envelope.new': 'New envelope',
    'components.envelope.namePlaceholder': 'Groceries',
    'components.envelope.limit': (p: { period: string; currency: string }) => `Limit for ${p.period}, ${p.currency}`,
    'components.envelope.carriedHint': (p: { sum: string }) => `${p.sum} of the limit rolled over from the previous period.`,
    'components.envelope.limitHint': 'If empty, the envelope has no limit and just counts expenses.',
    'components.envelope.color': 'Color',
    'components.envelope.colorAria': 'Envelope color',
    'components.envelope.create': 'Create envelope',
    'components.envelope.remove': 'Remove envelope',
    'components.tx.deleteConfirm': 'Delete this expense?',
    'components.tx.title': 'Expense',
    'components.tx.fromPayment': 'Created from a planned payment',
    'components.tx.amount': 'Expense amount',
    'components.tx.dateHint': 'Moving the expense to another period moves it into that budget.',
    'components.tx.delete': 'Delete expense',
    'components.sub.deleteConfirm': (p: { name: string }) => `Delete subscription "${p.name}"?`,
    'components.sub.new': 'New subscription',
    'components.sub.subtitle': 'Recurring charge',
    'components.sub.amount': (p: { currency: string }) => `Monthly amount, ${p.currency}`,
    'components.sub.day': 'Charge day',
    'components.sub.dayHint': 'In shorter months the 29th to 31st move to the last day.',
    'components.sub.noteHint': 'For example, which card it is charged to.',
    'components.sub.delete': 'Delete subscription',
    'components.entry.left': (p: { sum: string }) => `${p.sum} left`,
    'components.entry.envelope': 'Envelope',
    'components.entry.description': (p: { name: string }) => `New expense in envelope "${p.name}"`,
    'components.entry.currencySwitch': (p: { currency: string }) => `Currency ${p.currency}, switch`,
    'components.entry.erase': 'Erase',
    'components.entry.submit': (p: { sum: string }) => `Add ${p.sum}`,
  },
  be: {
    'components.category': 'Катэгорыя',
    'components.currency': 'Валюта',
    'components.close': 'Закрыць',
    'components.amount': 'Сума',
    'components.amountRequired': 'Увядзіце суму',
    'components.amountPositive': 'Сума павінна быць большай за нуль',
    'components.amountInvalid': 'Некарэктная сума',
    'components.back': 'Назад',
    'components.settings': 'Налады',
    'components.prevPeriod': 'Папярэдні перыяд',
    'components.nextPeriod': 'Наступны перыяд',
    'components.backToCurrent': (p: { label: string }) => `${p.label}: вярнуцца да бягучага перыяду`,
    'components.loading': 'Загрузка',
    'components.retry': 'Паўтарыць',
    'components.today': 'Сёння',
    'components.yesterday': 'Учора',
    'components.date': 'Дата',
    'components.otherDate': 'Іншая дата',
    'components.txDate': 'Дата траты',
    'components.name': 'Назва',
    'components.nameRequired': 'Увядзіце назву',
    'components.note': 'Нататка',
    'components.optional': 'неабавязкова',
    'components.save': 'Захаваць',
    'components.dayError': 'Дзень павінен быць ад 1 да 31',
    'components.noLimit': 'без ліміту',
    'components.payment.deleteConfirm': (p: { name: string }) => `Выдаліць плацёж «${p.name}»?`,
    'components.payment.new': 'Новы плацёж',
    'components.payment.planSubtitle': (p: { amount: string; date: string }) => `План: ${p.amount} · да ${p.date}`,
    'components.payment.namePlaceholder': 'Арэнда',
    'components.payment.plannedAmount': (p: { currency: string }) => `Плановая сума, ${p.currency}`,
    'components.payment.day': 'Дзень месяца',
    'components.payment.dayHint': 'Калі ў месяцы менш дзён, плацёж зрушыцца на апошні.',
    'components.payment.categoryHint': 'Катэгорыя патрэбна, каб плацёж трапіў у бюджэт.',
    'components.payment.categoriesFailed': 'Катэгорыі не загрузіліся',
    'components.payment.monthly': 'Паўтараецца штомесяц',
    'components.payment.paid': 'Аплачана',
    'components.payment.paidOn': 'Адзначана як аплачанае',
    'components.payment.paidHint': 'Адзнака дзейнічае толькі на выбраны перыяд',
    'components.payment.actualAmount': (p: { currency: string }) => `Фактычная сума, ${p.currency}`,
    'components.payment.actualHint': 'Пакіньце пустым, калі спісалася роўна як у плане.',
    'components.payment.actualPlaceholder': (p: { amount: string }) => `як у плане (${p.amount})`,
    'components.payment.delete': 'Выдаліць плацёж',
    'components.envelope.removeConfirm': (p: { name: string }) => `Прыбраць канверт «${p.name}»? Траты і гісторыя застануцца.`,
    'components.envelope.removeOk': 'Прыбраць',
    'components.envelope.title': 'Канверт',
    'components.envelope.new': 'Новы канверт',
    'components.envelope.namePlaceholder': 'Прадукты',
    'components.envelope.limit': (p: { period: string; currency: string }) => `Ліміт на ${p.period}, ${p.currency}`,
    'components.envelope.carriedHint': (p: { sum: string }) => `У ліміце ${p.sum} перанесена з мінулага перыяду.`,
    'components.envelope.limitHint': 'Калі пуста, канверт без ліміту проста лічыць траты.',
    'components.envelope.color': 'Колер',
    'components.envelope.colorAria': 'Колер канверта',
    'components.envelope.create': 'Завесці канверт',
    'components.envelope.remove': 'Прыбраць канверт',
    'components.tx.deleteConfirm': 'Выдаліць гэтую трату?',
    'components.tx.title': 'Трата',
    'components.tx.fromPayment': 'Створана з планавага плацяжу',
    'components.tx.amount': 'Сума траты',
    'components.tx.dateHint': 'Калі перанесці трату ў іншы перыяд, яна пяройдзе ў яго бюджэт.',
    'components.tx.delete': 'Выдаліць трату',
    'components.sub.deleteConfirm': (p: { name: string }) => `Выдаліць падпіску «${p.name}»?`,
    'components.sub.new': 'Новая падпіска',
    'components.sub.subtitle': 'Рэгулярнае спісанне',
    'components.sub.amount': (p: { currency: string }) => `Сума ў месяц, ${p.currency}`,
    'components.sub.day': 'Дзень спісання',
    'components.sub.dayHint': 'У кароткіх месяцах 29–31 зрушваецца на апошні дзень.',
    'components.sub.noteHint': 'Напрыклад, з якой карты спісваецца.',
    'components.sub.delete': 'Выдаліць падпіску',
    'components.entry.left': (p: { sum: string }) => `засталося ${p.sum}`,
    'components.entry.envelope': 'Канверт',
    'components.entry.description': (p: { name: string }) => `Новая трата ў канверт «${p.name}»`,
    'components.entry.currencySwitch': (p: { currency: string }) => `Валюта ${p.currency}, змяніць`,
    'components.entry.erase': 'Сцерці',
    'components.entry.submit': (p: { sum: string }) => `Запісаць ${p.sum}`,
  },
});
